import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const planIncrementsRoute: InvariantJiraRoute = {
	name: 'software-plan-increments',
	path: '/jira/plans/:planId/scenarios/:scenarioId/program',
	exact: true,
};
